import { render, staticRenderFns } from "./toast-notification.vue?vue&type=template&id=54dfcef7&scoped=true&lang=pug"
import script from "./toast-notification.js?vue&type=script&lang=js&external"
export * from "./toast-notification.js?vue&type=script&lang=js&external"
import style0 from "./toast-notification.vue?vue&type=style&index=0&id=54dfcef7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfcef7",
  null
  
)

export default component.exports